/* ZCRAVE header parity behaviours (loaded after theme.js).
   - rail: slick-style fade slider, autoplay 6000ms, 600ms crossfade, no pause on hover (live #top-bar)
   - stamp: "City | Mon D, YYYY" in New York time (live prints the NY date)
   - cart count: hide when zero, exactly like live .et-count-zero
   - UP control: live #zcrave-scrollup (show past 400px, smooth scroll to top) */
(function () {
  'use strict';
  function init() {
    /* rail */
    document.querySelectorAll('[data-zrail]').forEach(function (rail) {
      var slides = Array.prototype.slice.call(rail.querySelectorAll('.z-rail__slide'));
      if (slides.length < 2 || rail.dataset.mode !== 'rotate') return;
      var i = 0, timer = null, every = Number(rail.dataset.interval) || 6000;
      /* live slick restarts its autoplay timer AFTER the fade finishes, so the real cadence is
         autoplaySpeed + speed, not autoplaySpeed. Measured on zcrave.com 2026-09-08 by polling
         slide opacity: fade starts 6592ms and 6638ms apart (6000 + the ~600ms crossfade), and the
         crossfade itself runs ~462ms of visible mid-opacity vs our 465ms. A flat 6000ms
         setInterval ran the rail ~600ms per cycle fast. */
      var FADE = 600;
      function show(n) {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      }
      function tick() { show(i + 1); timer = setTimeout(tick, every + FADE); }
      function start() { stop(); timer = setTimeout(tick, every + FADE); }
      function stop() { if (timer) { clearTimeout(timer); timer = null; } }
      start(); /* live slick: pauseOnHover false */
    });

    /* stamp date: live prints the visitor's local date */
    document.querySelectorAll('.z-rail__stamp a[data-zcv-city]').forEach(function (a) {
      try {
        var d = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        a.textContent = a.getAttribute('data-zcv-city') + ' | ' + d;
      } catch (e) {}
    });

    /* cart counter */
    var count = document.querySelector('[data-cart-count]');
    if (count) {
      var sync = function () { count.classList.toggle('et-count-zero', !(parseInt(count.textContent, 10) > 0)); };
      sync();
      new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
    }

    /* live goya: body.header_on_scroll once scrollY > 60 (border + 56px header) */
    var onScroll = function () { document.body.classList.toggle('header_on_scroll', window.scrollY > 60); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* search overlay: scrim + body class follow theme.js's .is-open; results grid like live autocomplete */
    var sp = document.querySelector('[data-search-panel]');
    var cap = document.querySelector('.z-search-capture');
    if (sp && cap) {
      var syncSearch = function () {
        var open = sp.classList.contains('is-open');
        document.body.classList.toggle('panel-open-search', open);
        if (open) { cap.hidden = false; requestAnimationFrame(function () { cap.classList.add('is-on'); }); }
        else { cap.classList.remove('is-on'); setTimeout(function () { if (!sp.classList.contains('is-open')) cap.hidden = true; }, 450); }
      };
      new MutationObserver(syncSearch).observe(sp, { attributes: true, attributeFilter: ['class'] });
      syncSearch();
      var form = sp.querySelector('[data-zsearch]');
      var input = form && form.querySelector('input[type="search"]');
      var box = form && form.querySelector('[data-zsearch-results]');
      if (form && input && box) {
        var t = null, ctrl = null;
        var money = function (v) {
          var n = Number(v); if (!isFinite(n)) return String(v);
          return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        };
        var esc = function (x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
        var img = function (p) {
          var u = (p.featured_image && p.featured_image.url) || p.image || '';
          if (!u) return '';
          return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=600';
        };
        var render = function (q, list) {
          if (!list.length) { box.hidden = true; box.innerHTML = ''; return; }
          var h = '<ul class="product_list_widget row">';
          list.forEach(function (p) {
            var onSale = p.compare_at_price_max && Number(p.compare_at_price_max) > Number(p.price);
            h += '<li class="autocomplete-suggestion"><a href="' + esc(p.url) + '">'
              + (img(p) ? '<img src="' + esc(img(p)) + '" alt="" width="600" height="800" loading="lazy">' : '')
              + '<span class="product-title">' + esc(p.title) + '</span>'
              + '<span class="zs-price">' + (onSale ? '<del aria-hidden="true">' + money(p.compare_at_price_max) + '</del> <ins aria-hidden="true">' + money(p.price) + '</ins>'
                        : '<ins aria-hidden="true">' + money(p.price) + '</ins>') + '</span>'
              + '</a></li>';
          });
          h += '<li class="autocomplete-suggestion view-all-row"><button type="submit" class="button outlined btn-sm view-all">View All</button></li></ul>';
          box.innerHTML = h; box.hidden = false;
        };
        input.addEventListener('input', function () {
          var q = input.value.trim();
          clearTimeout(t);
          if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
          t = setTimeout(function () {
            if (ctrl) ctrl.abort();
            ctrl = new AbortController();
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor', { signal: ctrl.signal })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (j) { render(q, (j && j.resources && j.resources.results && j.resources.results.products) || []); })
              .catch(function () {});
          }, 220);
        });
      }
    }


    /* ---------- mobile off-canvas menu (live nav#mobile-menu, <=991px) ----------
       burger toggles the sheet (slide from the left + fade, 250ms) and turns into an X;
       a parent row slides its child panel in (goya slidingMenu, transitionDuration 200);
       the back row (labelled with the parent title) slides back; while a child panel is
       open the bottom extras are hidden, exactly like live's #mobile-menu.submenu-open. */
    var mmenu = document.querySelector('[data-mmenu]');
    var zburger = document.querySelector('[data-zburger]');
    var mslider = document.querySelector('[data-mmenu-slider]');
    if (mmenu && zburger) {
      var panelOf = function (id) { return mslider && mslider.querySelector('[data-mmenu-panel="' + id + '"]'); };
      var sized = false;
      var sizeSlider = function (panel) {
        if (!mslider || !panel) return;
        /* the very first sizing (and the reset after the sheet closes) must not animate */
        if (!sized || !mmenu.classList.contains('is-open')) {
          mslider.style.transition = 'none';
          mslider.style.height = panel.scrollHeight + 'px';
          void mslider.offsetHeight;
          mslider.style.transition = '';
          sized = true;
          return;
        }
        mslider.style.height = panel.scrollHeight + 'px';
      };
      var showPanel = function (id) {
        if (!mslider) return;
        var panels = mslider.querySelectorAll('[data-mmenu-panel]');
        Array.prototype.forEach.call(panels, function (p) {
          var isTarget = p.getAttribute('data-mmenu-panel') === id;
          p.classList.toggle('is-active', isTarget);
          /* the root parks to the left when a child is showing; children park to the right */
          p.classList.toggle('is-past', !isTarget && id !== 'root' && p.getAttribute('data-mmenu-panel') === 'root');
          p.setAttribute('aria-hidden', String(!isTarget));
        });
        mmenu.classList.toggle('submenu-open', id !== 'root');
        if (mslider) mslider.classList.toggle('submenu-open', id !== 'root');
        sizeSlider(panelOf(id));
        mslider.scrollTop = 0;
      };
      var setMenu = function (open) {
        mmenu.classList.toggle('is-open', open);
        zburger.classList.toggle('clicked', open);
        zburger.setAttribute('aria-expanded', String(open));
        mmenu.setAttribute('aria-hidden', String(!open));
        document.body.classList.toggle('panel-open-menu', open);
        if (!open) setTimeout(function () { if (!mmenu.classList.contains('is-open')) showPanel('root'); }, 260);
      };
      zburger.addEventListener('click', function (e) {
        e.preventDefault();
        setMenu(!mmenu.classList.contains('is-open'));
      });
      if (mslider) {
        showPanel('root');
        mslider.addEventListener('click', function (e) {
          var nav = e.target.closest('[data-mmenu-to]');
          if (!nav) return;
          e.preventDefault();
          showPanel(nav.getAttribute('data-mmenu-to'));
        });
        window.addEventListener('resize', function () {
          var active = mslider.querySelector('[data-mmenu-panel].is-active') || panelOf('root');
          sizeSlider(active);
        }, { passive: true });
      }
      /* the search sheet / cart drawer take over the screen: close the menu first */
      document.addEventListener('click', function (e) {
        if (!mmenu.classList.contains('is-open')) return;
        if (e.target.closest('[data-search-open],[data-cart-open]')) setMenu(false);
      }, true);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mmenu.classList.contains('is-open')) setMenu(false);
      });
    }


    /* footer accordions on mobile (live .footer-toggle-widgets: the widget body slides open with
       jQuery slideToggle + fade, ~300ms swing - height, bottom padding and opacity together). */
    document.addEventListener('click', function (e) {
      var head = e.target.closest('.zf .zf__head');
      if (!head || window.matchMedia('(min-width:992px)').matches) return;
      var col = head.parentElement;
      var list = col && col.querySelector('.zf__list');
      if (!list) return;
      var open = !col.classList.contains('is-open');
      /* start from a measured pixel height so the transition has something to run between */
      list.style.height = (open ? 0 : list.scrollHeight) + 'px';
      col.classList.remove('is-settled');
      void list.offsetHeight;
      col.classList.toggle('is-open', open);
      list.style.height = (open ? list.scrollHeight : 0) + 'px';
      if (list._zfEnd) list.removeEventListener('transitionend', list._zfEnd);
      list._zfEnd = function (ev) {
        if (ev.target !== list || ev.propertyName !== 'height') return;
        list.removeEventListener('transitionend', list._zfEnd);
        list._zfEnd = null;
        list.style.height = '';
        if (col.classList.contains('is-open')) col.classList.add('is-settled');
      };
      list.addEventListener('transitionend', list._zfEnd);
    });

    /* UP */
    var wrap = document.getElementById('zcrave-scrollup');
    if (wrap) {
      var showAt = 400;
      var toggle = function () {
        if (window.scrollY > showAt) wrap.classList.add('is-visible');
        else wrap.classList.remove('is-visible');
      };
      var up = function (e) { if (e) e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); };
      wrap.addEventListener('click', up);
      wrap.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); up(); } });
      toggle();
      window.addEventListener('scroll', toggle, { passive: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
